export const ADD_SAVED_LISTING_PREVIEW_GTM = '_addtosavedlistings_listing_preview';
export const ADD_SAVED_LISTING_PAGE_GTM = '_addtosavedlistings_listing_page';
export const ADD_SAVED_LANDING_PAGE_GTM = '_addtosavedListings_landing_page';
export const CONTACT_AGENT_RES = 'residential_contact_agent';
export const ASK_QUESTION_RES = 'residential_ask_a_question';
export const CONTACT_AGENT_COMM = 'commercial_contact_agent';
export const ASK_QUESTION_COMM = 'commercial_ask_a_question';
export const REQUEST_DETAILS_LUX = 'collection_request_more_details';
export const CONTACT_AGENT_LUX = 'collection_contact_an_agent';
export const CONTACT_AGENT_PAGE = 'agentpage_ask_agent_a_question';
export const CONTACT_OFFICE_PAGE = 'brokerpage_ask_broker_a_question';
export const SITE_SEARCH = 'site_search';
export const SITE_SEARCH_TERM = 'keyword_search';
export const GO_TO_AGENT_RES = 'residential_goto_agents_profile';
export const GO_TO_AGENT_COMM = 'commercial_goto_agents_profile';
export const GO_TO_AGENT_LUX = 'collection_goto_agents_profile';
export const OFFICE_SEARCH_EMAIL = 'email_office_officesearch';
export const AGENT_SEARCH_EMAIL = 'email_agent_agentsearch';
export const INFINITE_SCROLL = 'remax_mobile_pagescroll';
export const SEND_LISTING_SCHEDULE_VIEWING = 'send_listing_schedule_viewing';
export const SEND_LUX_LISTING_SCHEDULE_VIEWING = 'send_lux_listing_schedule_viewing';
export const SEND_COMM_LISTING_SCHEDULE_VIEWING = 'send_comm_listing_schedule_viewing';
export const NOTIFICATION_CHECKBOX_VALUE = 'notification_checkbox_value';
export const NOTIFICAITON_EMAIL_UNSUBSCRIBE = 'notification_email_unsubscribe';
